export default __webpack_public_path__ + "static/media/professional.55ef1918.svg";